import React, { Component } from 'react'
import Highcharts from 'highcharts'
import { lineChartConfig, barChartConfig } from './config'
import TooltipCreator from './TooltipCreator'
import moment from 'moment'
import { equals } from 'ramda'
import { Div } from '@driftt/tide-core'

Highcharts.setOptions({
  chart: {
    style: {
      fontFamily: 'ProximaNova-Regular'
    }
  }
})

const TooltipFormat = () => {
  return function() {
    return TooltipCreator(this.points, this.x)
  }
}

export class PlaybookReportingLineGraph extends Component {

  componentDidMount() {
    const { data, colors } = this.props

    const config = {
      ...lineChartConfig,
      tooltip: {
        formatter: TooltipFormat(),
        borderWidth: 0,
        backgroundColor: null,
        useHTML: true,
        shared: true,
      },
      series: [
        {
          name: 'Current',
          data: data[0].data,
          color: colors[0],
          zIndex: 2,
          pointInterval: 24 * 3600 * 1000
        },
        {
          name: 'Previous',
          data: data[1].data,
          color: colors[1],
          zIndex: 1,
          pointInterval: 24 * 3600 * 1000,
        },
      ]
    }

    this.chart = new Highcharts['Chart']('email-report-chart', config)

  }

  componentDidUpdate(prevProps) {
    const { data } = this.props

    if (!equals(prevProps.data, data)) {
      this.chart.series[0].setData(data[0].data)
      this.chart.series[1].setData(data[1].data)


      this.chart.redraw()
    }
  }

  componentWillUnmount() {
    this.chart.destroy()
  }

  render() {
    return(
      <Div id="email-report-chart"></Div>
    )
  }
}
const BarChartTooltip = () => {
  return function() {
    const headerDate = moment.utc(this.x).format('MM/DD')
    return `<b>${headerDate}</b><br/>${this.point.series.name}: ${this.point.y}<br/>Total: ${this.point.stackTotal}`
  }
}

export class PlaybookReportingStackedBars extends Component {
  componentDidMount() {
    const { data } = this.props

    const config = {
      ...barChartConfig,
      xAxis: {
        categories: data.xAxisBuckets,
        labels: {
          formatter: function() {
                return Highcharts.dateFormat('%m/%d', this.value);
           }
        },
      },
      series: data.stackedValues,
      tooltip: {
        formatter: BarChartTooltip()
      }
    }

    this.chart = new Highcharts['Chart']('email-report-chart', config)
  }

  componentDidUpdate(prevProps) {
    const { data } = this.props

    if (!equals(prevProps.data, data)) {
      this.chart.xAxis[0].setCategories(data.xAxisBuckets)
      this.chart.series[0].setData(data.stackedValues[0].data)
      this.chart.series[1].setData(data.stackedValues[1].data)

      this.chart.redraw()
    }
  }

  componentWillUnmount() {
    this.chart.destroy()
  }

  render() {
    return (
      <Div id="email-report-chart"></Div>
    )
  }
}
